import { cn } from "@/lib/utils";

type BrandProps = {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  stacked?: boolean; // ヒーロー用に改行するか
};

export function Brand({ className, size = "lg", stacked = false }: BrandProps) {
  const sizeCls =
    size === "xl" ? "text-4xl md:text-5xl" :
    size === "lg" ? "text-3xl md:text-4xl" :
    size === "md" ? "text-2xl" : "text-xl";

  const text = "フタリノタベログ";

  return (
    <span
      className={cn(
        "font-extrabold tracking-wider",
        "bg-gradient-to-r from-primary via-accent to-primary",
        "bg-clip-text text-transparent",
        "drop-shadow-[0_1px_1px_rgba(0,0,0,0.15)]",
        sizeCls,
        className
      )}
      aria-label={text}
    >
      {stacked ? (
        <>
          <span>フタリノ</span>
          <br className="hidden sm:block" />
          <span>タベログ</span>
        </>
      ) : (
        text
      )}
    </span>
  );
}

export default Brand;

